if (!customElements.get('postaldata-api')) {
    class PostaldataApi extends HTMLElement{
        constructor() {
            super();
            this.query = this.querySelector('.search-query');
            this.country = this.querySelector('.postal-country');
            this.suggestions = this.querySelector('.suggestions');
            this.output = this.querySelector('.output');
            this.outputResult = this.querySelector('.search-result');
            this.outputPagination = this.querySelector('.pagination');
            this.pageNumber = this.querySelector('.pageNumber');
            this.searchBtn = this.querySelector('.btn-search');

            this.endpoint = this.querySelector('.endpoint').value;

            if(!this.endpoint.includes("countries")){
                
                this.getCountries().forEach(ct=>{
                    const option = document.createElement("option");
                    option.value = ct.name;
                    option.textContent = ct.label;
                    this.country.appendChild(option);
                })
            }

            this.addEventListeners();
        }

        debounce(fn, delay) {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn(...args), delay);
            };
        }

        getCountries(){
            const countries = [
                { "name": "US", "label": "United States" },
                { "name": "CA", "label": "Canada" },
                { "name": "AU", "label": "Australia" },
                { "name": "DE", "label": "Germany" },
                { "name": "GB", "label": "United Kingdom" },
                { "name": "NL", "label": "Netherlands" },
                { "name": "BE", "label": "Belgium" },
                { "name": "FR", "label": "France" },
                { "name": "ES", "label": "Spain" },
                { "name": "IT", "label": "Italy" },
                { "name": "AF", "label": "Afghanistan" },
                { "name": "AL", "label": "Albania" },
                { "name": "DZ", "label": "Algeria" },
                { "name": "AD", "label": "Andorra" },
                { "name": "AO", "label": "Angola" },
                { "name": "AR", "label": "Argentina" },
                { "name": "AM", "label": "Armenia" },
                { "name": "AT", "label": "Austria" },
                { "name": "AZ", "label": "Azerbaijan" },
                { "name": "BS", "label": "Bahamas" },
                { "name": "BH", "label": "Bahrain" },
                { "name": "BD", "label": "Bangladesh" },
                { "name": "BY", "label": "Belarus" },
                { "name": "BZ", "label": "Belize" },
                { "name": "BJ", "label": "Benin" },
                { "name": "BM", "label": "Bermuda" },
                { "name": "BT", "label": "Bhutan" },
                { "name": "BO", "label": "Bolivia" },
                { "name": "BA", "label": "Bosnia and Herzegovina" },
                { "name": "BW", "label": "Botswana" },
                { "name": "BR", "label": "Brazil" },
                { "name": "BN", "label": "Brunei Darussalam" },
                { "name": "BG", "label": "Bulgaria" },
                { "name": "BF", "label": "Burkina Faso" },
                { "name": "BI", "label": "Burundi" },
                { "name": "KH", "label": "Cambodia" },
                { "name": "CM", "label": "Cameroon" },
                { "name": "BQ", "label": "Caribbean Netherlands" },
                { "name": "CF", "label": "Central African Republic" },
                { "name": "TD", "label": "Chad" },
                { "name": "CL", "label": "Chile" },
                { "name": "CN", "label": "China" },
                { "name": "CX", "label": "Christmas Island" },
                { "name": "CC", "label": "Cocos Islands" },
                { "name": "CO", "label": "Colombia" },
                { "name": "KM", "label": "Comoros" },
                { "name": "CR", "label": "Costa Rica" },
                { "name": "CI", "label": "Côte d'Ivoire" },
                { "name": "HR", "label": "Croatia" },
                { "name": "CU", "label": "Cuba" },
                { "name": "CZ", "label": "Czech Republic" },
                { "name": "CD", "label": "Democratic Republic of the Congo" },
                { "name": "DK", "label": "Denmark" },
                { "name": "DJ", "label": "Djibouti" },
                { "name": "DO", "label": "Dominican Republic" },
                { "name": "TL", "label": "East Timor" },
                { "name": "EC", "label": "Ecuador" },
                { "name": "EG", "label": "Egypt" },
                { "name": "SV", "label": "El Salvador" },
                { "name": "GQ", "label": "Equatorial Guinea" },
                { "name": "ER", "label": "Eritrea" },
                { "name": "EE", "label": "Estonia" },
                { "name": "ET", "label": "Ethiopia" },
                { "name": "FK", "label": "Falkland Islands" },
                { "name": "FO", "label": "Faroe Islands" },
                { "name": "FJ", "label": "Fiji" },
                { "name": "FI", "label": "Finland" },
                { "name": "GF", "label": "French Guiana" },
                { "name": "GA", "label": "Gabon" },
                { "name": "GE", "label": "Georgia" },
                { "name": "GH", "label": "Ghana" },
                { "name": "GI", "label": "Gibraltar" },
                { "name": "GR", "label": "Greece" },
                { "name": "GL", "label": "Greenland" },
                { "name": "GP", "label": "Guadeloupe" },
                { "name": "GU", "label": "Guam" },
                { "name": "GT", "label": "Guatemala" },
                { "name": "GG", "label": "Guernsey" },
                { "name": "GN", "label": "Guinea" },
                { "name": "GW", "label": "Guinea-Bissau" },
                { "name": "GY", "label": "Guyana" },
                { "name": "HT", "label": "Haiti" },
                { "name": "HN", "label": "Honduras" },
                { "name": "HU", "label": "Hungary" },
                { "name": "IS", "label": "Iceland" },
                { "name": "IN", "label": "India" },
                { "name": "ID", "label": "Indonesia" },
                { "name": "IR", "label": "Iran" },
                { "name": "IQ", "label": "Iraq" },
                { "name": "IE", "label": "Ireland" },
                { "name": "IM", "label": "Isle of Man" },
                { "name": "IL", "label": "Israel" },
                { "name": "JP", "label": "Japan" },
                { "name": "JE", "label": "Jersey" },
                { "name": "JO", "label": "Jordan" },
                { "name": "KZ", "label": "Kazakhstan" },
                { "name": "KE", "label": "Kenya" },
                { "name": "KI", "label": "Kiribati" },
                { "name": "XK", "label": "Kosovo" },
                { "name": "KW", "label": "Kuwait" },
                { "name": "KG", "label": "Kyrgyzstan" },
                { "name": "LA", "label": "Laos" },
                { "name": "LV", "label": "Latvia" },
                { "name": "LB", "label": "Lebanon" },
                { "name": "LS", "label": "Lesotho" },
                { "name": "LR", "label": "Liberia" },
                { "name": "LY", "label": "Libya" },
                { "name": "LI", "label": "Liechtenstein" },
                { "name": "LT", "label": "Lithuania" },
                { "name": "LU", "label": "Luxembourg" },
                { "name": "MK", "label": "Macedonia" },
                { "name": "MG", "label": "Madagascar" },
                { "name": "MW", "label": "Malawi" },
                { "name": "MY", "label": "Malaysia" },
                { "name": "ML", "label": "Mali" },
                { "name": "MT", "label": "Malta" },
                { "name": "MQ", "label": "Martinique" },
                { "name": "MR", "label": "Mauritania" },
                { "name": "MU", "label": "Mauritius" },
                { "name": "YT", "label": "Mayotte" },
                { "name": "MX", "label": "Mexico" },
                { "name": "MD", "label": "Moldova" },
                { "name": "MC", "label": "Monaco" },
                { "name": "MN", "label": "Mongolia" },
                { "name": "ME", "label": "Montenegro" },
                { "name": "MA", "label": "Morocco" },
                { "name": "MZ", "label": "Mozambique" },
                { "name": "MM", "label": "Myanmar" },
                { "name": "NA", "label": "Namibia" },
                { "name": "NP", "label": "Nepal" },
                { "name": "NZ", "label": "New Zealand" },
                { "name": "NI", "label": "Nicaragua" },
                { "name": "NE", "label": "Niger" },
                { "name": "NG", "label": "Nigeria" },
                { "name": "NF", "label": "Norfolk Island" },
                { "name": "KP", "label": "North Korea" },
                { "name": "NO", "label": "Norway" },
                { "name": "OM", "label": "Oman" },
                { "name": "PK", "label": "Pakistan" },
                { "name": "PS", "label": "Palestinian Territory" },
                { "name": "PA", "label": "Panama" },
                { "name": "PG", "label": "Papua New Guinea" },
                { "name": "PY", "label": "Paraguay" },
                { "name": "PE", "label": "Peru" },
                { "name": "PH", "label": "Philippines" },
                { "name": "PL", "label": "Poland" },
                { "name": "PT", "label": "Portugal" },
                { "name": "PR", "label": "Puerto Rico" },
                { "name": "QA", "label": "Qatar" },
                { "name": "CG", "label": "Republic of the Congo" },
                { "name": "RE", "label": "Reunion" },
                { "name": "RO", "label": "Romania" },
                { "name": "RU", "label": "Russia" },
                { "name": "RW", "label": "Rwanda" },
                { "name": "BL", "label": "Saint-Barthelemy" },
                { "name": "MF", "label": "Saint Martin" },
                { "name": "PM", "label": "Saint Pierre and Miquelon" },
                { "name": "WS", "label": "Samoa" },
                { "name": "SM", "label": "San Marino" },
                { "name": "SA", "label": "Saudi Arabia" },
                { "name": "SN", "label": "Senegal" },
                { "name": "RS", "label": "Serbia" },
                { "name": "SC", "label": "Seychelles" },
                { "name": "SL", "label": "Sierra Leone" },
                { "name": "SG", "label": "Singapore" },
                { "name": "SX", "label": "Sint Maarten" },
                { "name": "SK", "label": "Slovakia" },
                { "name": "SI", "label": "Slovenia" },
                { "name": "SO", "label": "Somalia" },
                { "name": "ZA", "label": "South Africa" },
                { "name": "KR", "label": "South Korea" },
                { "name": "SS", "label": "South Sudan" },
                { "name": "LK", "label": "Sri Lanka" },
                { "name": "SD", "label": "Sudan" },
                { "name": "SR", "label": "Suriname" },
                { "name": "SZ", "label": "Swaziland" },
                { "name": "SE", "label": "Sweden" },
                { "name": "CH", "label": "Switzerland" },
                { "name": "SY", "label": "Syria" },
                { "name": "TW", "label": "Taiwan" },
                { "name": "TJ", "label": "Tajikistan" },
                { "name": "TZ", "label": "Tanzania" },
                { "name": "TH", "label": "Thailand" },
                { "name": "GM", "label": "The Gambia" },
                { "name": "TG", "label": "Togo" },
                { "name": "TN", "label": "Tunisia" },
                { "name": "TR", "label": "Turkey" },
                { "name": "TM", "label": "Turkmenistan" },
                { "name": "VI", "label": "U.S. Virgin Islands" },
                { "name": "UG", "label": "Uganda" },
                { "name": "UA", "label": "Ukraine" },
                { "name": "AE", "label": "United Arab Emirates" },
                { "name": "UY", "label": "Uruguay" },
                { "name": "UZ", "label": "Uzbekistan" },
                { "name": "VU", "label": "Vanuatu" },
                { "name": "VA", "label": "Vatican" },
                { "name": "VE", "label": "Venezuela" },
                { "name": "VN", "label": "Vietnam" },
                { "name": "EH", "label": "Western Sahara" },
                { "name": "YE", "label": "Yemen" },
                { "name": "ZM", "label": "Zambia" },
                { "name": "ZW", "label": "Zimbabwe" }
            ];
            return countries;
        }

        addEventListeners(){
            this.debouncedInputChange = this.debounce(this.inputChange.bind(this), 600);
            // Save as soon as possible, avoid link-click not providing time to save
            if(this.endpoint.includes('autocomplete')){
                this.query.addEventListener('input', this.debouncedInputChange);
                if(!this.endpoint.includes('countries')){
                    this.country.addEventListener('change', this.debouncedInputChange);
                }
            }
            this.searchBtn.addEventListener('click', this.inputChange.bind(this));

            document.addEventListener('click', e => {
                if (!this.contains(e.target)) this.suggestions.style.display = 'none';
            });
        }

        inputChange(e){
            if(!this.endpoint.includes('countries') && this.endpoint != 'addresses'){
                const term = this.query.value.trim();
                if (term.length < 3 && this.endpoint.includes('autocomplete')) {
                    this.suggestions.style.display = 'none';
                    return;
                }
            }
            if(this.querySelector('.search-id')) this.endpoint = "addresses/" + this.querySelector('.search-id').value
            const apiKey = "mRuB3IUUnkO1mnW-qfDTGogVqaqi6y2tDwlErd6AwBVh_noqCWkBsZIGaZEfFhHXidL6QtBk3pOJHsn1";
            const apiUrl = "https://api.listreet.com/api/v1/" + this.endpoint;

            let params = {};
            if(this.endpoint == 'streets'){
                params = {
                    'name': this.query.value,
                    'locality': this.querySelector('.search-locality').value,
                    'postal_code': this.querySelector('.search-postcode').value,
                    'page': this.pageNumber.value,
                    'size': 10
                };
            }else if(this.endpoint == 'postcodes'){
                params = {
                    'postal_code': this.query.value,
                    'page': this.pageNumber.value,
                    'size': 10
                }
            }else if(this.endpoint == 'postal-codes'){
                params = {
                    'postal_code': this.query.value,
                    'page': this.pageNumber.value,
                    'size': 10
                }
            }else if(this.endpoint == 'zip-codes'){
                params = {
                    'postal_code': this.query.value,
                    'page': this.pageNumber.value,
                    'size': 10
                }
            }else if(this.endpoint == 'localities'){
                params = {
                    'name': this.query.value,
                    'page': this.pageNumber.value,
                    'size': 10
                }
            }else if(this.endpoint == 'countries'){
                params = {
                    'name': this.query ? this.query.value : '',
                    'page': this.pageNumber.value,
                    'size': 10
                }
            }else if(this.endpoint == 'addresses'){
                if(this.querySelector('.search-id')){
                    params = {
                        'name': this.querySelector('.search-id').value,
                        'page': this.pageNumber.value,
                        'size': 10
                    }
                }else{
                    params = {
                        'region': this.querySelector('.search-region').value,
                        'locality': this.querySelector('.search-locality').value,
                        'postal_code': this.querySelector('.search-postal_code').value,
                        'street': this.querySelector('.search-street').value,
                        'house_number': this.querySelector('.search-house_number').value
                    }
                }
            }else if(this.endpoint.includes('autocomplete')){
                params = {
                    'query': this.query.value,
                    'page': this.pageNumber.value,
                    'size': 10
                }
            }
            if (!this.endpoint.includes("countries")) {
                params.country_code = this.country.value;
            }

            this.searchBtn.disabled = true;
            this.output.classList.add('loading');
            fetch( 
                apiUrl + '?' + new URLSearchParams(params).toString(),
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": apiKey
                    }
                }
            )
            .then(res=>res.json())
            .then(res=>{
                this.output.classList.remove('loading');
                console.log("Fetch result", res);
                this.searchBtn.disabled = false;
                if(res.hasOwnProperty('error')){
                    this.outputResult.innerHTML = "<div class='alert alert-error'>"+res.message+"</div>";
                    this.outputPagination.innerHTML = '';
                }else if(res.hasOwnProperty('message')){
                    this.outputResult.innerHTML = "<div class='alert alert-error'>"+res.message+"</div>";
                    this.outputPagination.innerHTML = '';
                }else{
                    this.renderSuggestions(res);
                }
            })
            .catch(err => {
                console.error("Error:", err);
                this.output.classList.remove('loading');
                this.outputResult.innerHTML = "<div class='alert alert-error'>"+err.message+"</div>";
                this.outputPagination.innerHTML = '';
                this.searchBtn.disabled = false;
            });
        }

        renderSuggestions(res) {
            let items = res;
            if(this.endpoint != 'autocomplete' ){
                items = res.content;
            }
            if (!items || !items.length) {
                this.suggestions.style.display = "none";
                this.outputResult.innerHTML = "<div class='alert alert-info'>No results found.</div>";
                this.outputPagination.innerHTML = "";
                return;
            }

            if(this.endpoint.includes('autocomplete')){
                this.suggestions.innerHTML = "";
                this.suggestions.style.display = "block";

                items.forEach(itemData => {
                    const mainLabel = itemData[itemData.type] || "";

                    const secondary = [
                    itemData.street || "",
                    itemData.locality || "",
                    itemData.region || "",
                    itemData.country || "",
                    itemData.country_code || "",
                    itemData.postal_code || ""
                    ]
                    .filter(Boolean)
                    .join(" · ");

                    const item = document.createElement("div");
                    item.className = "suggestion-item";

                    item.innerHTML = `
                    <div class="suggestion-sub">${secondary}</div>
                    `;

                    item.onclick = () => {
                        this.query.value = secondary;
                        this.outputResult.innerHTML = this.formatLocationHTML(itemData);
                        this.suggestions.style.display = "none";
                    };

                    this.suggestions.appendChild(item);
                });
            }else{
                let outResult = '';
                items.forEach(itemData => {
                    outResult += this.formatLocationHTML(itemData);
                })

                this.outputResult.innerHTML = outResult;
                
                this.pageNumber.value = res.page.number;
                if(res.page.totalPages > 1){
                    this.renderPagination(res.page);
                }else {
                    this.outputPagination.innerHTML = "";
                }
            }
        }

        renderPagination(data) {
            const container = this.querySelector(".pagination");
            container.innerHTML = "";

            const currentPage = data.number;
            const totalPages = data.totalPages;

            // Previous button
            if (currentPage > 0) {
                const prev = document.createElement("button");
                prev.textContent = "Prev";
                prev.onclick = () => this.goToPage(currentPage - 1);
                container.appendChild(prev);
            }

            // Page numbers (limit visible pages)
            const maxVisible = 5;
            let start = Math.max(0, currentPage - 2);
            let end = Math.min(totalPages, start + maxVisible);

            for (let i = start; i < end; i++) {
                const btn = document.createElement("button");
                btn.textContent = i + 1;

                if (i === currentPage) {
                    btn.disabled = true;
                    btn.style.fontWeight = "bold";
                }

                btn.onclick = () => this.goToPage(i);
                container.appendChild(btn);
            }

            // Next button
            if (currentPage < totalPages - 1) {
                const next = document.createElement("button");
                next.textContent = "Next";
                next.onclick = () => this.goToPage(currentPage + 1);
                container.appendChild(next);
            }
        }

        goToPage(page) {
            console.log("Load page:", page);

            // Example: update and re-render
            this.pageNumber.value = page;
            this.searchBtn.dispatchEvent(new Event("click"));

        }

        formatLocationHTML(p) {
            const renderSection = (label, value) => {
                if (!value || value == '-') return ""; // skip section entirely
                return `
                <div class="pc-section">
                    <div class="pc-label">${label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()}</div>
                    <div class="pc-value">${value}</div>
                </div>
                `;
            };

            // const selectedType = p.type.charAt(0).to() + p.type.slice(1);
            let content = '';
            for (const [key, value] of Object.entries(p)) {
                content += renderSection(key, value);
            }

            return `
                <div class="pc-block">
                <div class="pc-title">Selected ${this.type ? this.type : this.endpoint}</div>
                ${content}
                </div>
            `;
        }
    }

    customElements.define('postaldata-api', PostaldataApi);
}